/**
 * This code was generated by v0 by Vercel.
 * @see https://v0.dev/t/zfulQUUi3PY
 */
import { Link } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import {
  DropdownMenuTrigger,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenu,
} from "../../../components/ui/dropdown-menu";
import {
  TableHead,
  TableRow,
  TableHeader,
  TableCell,
  TableBody,
  Table,
} from "../../../components/ui/table";
import { useNavigate } from "react-router-dom";

export const AllTripsView = ({ trips }) => {
  const navigate = useNavigate();
  const onEditClicked = (trip) => {
    const currentUrl = window.location.pathname.split('/').slice(0,-1).join('/');
    navigate(`${currentUrl}/createTrip/${trip.tripId}`);
  };

  return (
    <section className="container px-4 md:px-6 grid gap-10 items-start">
      <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
        <div className="text-sm font-semibold pl-4 sm:pl-0">Filter: </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="link">
              Month
              <PlusIcon className="w-4 h-4 ml-2" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuCheckboxItem>January</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>February</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>March</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>April</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>May</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>June</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>July</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>August</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>September</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>October</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>November</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>December</DropdownMenuCheckboxItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="link">
              Destination
              <PlusIcon className="w-4 h-4 ml-2" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuCheckboxItem>Paris</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem checked>Rome</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>New York</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>Tokyo</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>London</DropdownMenuCheckboxItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="link">
              Price
              <PlusIcon className="w-4 h-4 ml-2" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuCheckboxItem>₹ 3000 - ₹ 5000</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>
              ₹ 5000 - ₹ 15000
            </DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>
              ₹ 15000 - ₹ 40000
            </DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>₹ 40000+</DropdownMenuCheckboxItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="link">
              Status
              <PlusIcon className="w-4 h-4 ml-2" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuCheckboxItem>Live</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>Paused</DropdownMenuCheckboxItem>
            <DropdownMenuCheckboxItem>Ended</DropdownMenuCheckboxItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="border shadow-sm rounded-lg">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Trip Name</TableHead>
              <TableHead>Created Date</TableHead>
              <TableHead>Price</TableHead>
              <TableHead>Influencer</TableHead>
              <TableHead>Schedule</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {trips.map((trip, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">
                  <div className="flex items-center">
                    <Link
                      className="text-blue-500 hover:underline cursor-pointer"
                      to={`/trip/${trip.tripId}`}
                    >
                      {trip.tripName}
                    </Link>
                    <PencilIcon
                      className="h-8 w-8 ml-4 hover:bg-gray-200 p-2 hover:rounded"
                      onClick={() => onEditClicked(trip)}
                    />
                  </div>
                </TableCell>
                <TableCell>{trip.createdAt}</TableCell>
                <TableCell>{trip.price}</TableCell>
                <TableCell>{trip.influencerName}</TableCell>
                <TableCell>
                  <div>
                    {trip.schedules.map((string, index) => (
                      <p key={index}>{string}</p>
                    ))}
                  </div>
                </TableCell>
                <TableCell>{trip.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};

const PlusIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </svg>
  );
};

const PencilIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
      <path d="m15 5 4 4" />
    </svg>
  );
};
